import 'quasar/dist/quasar.ie.polyfills';
import Quasar, {Intersection, LoadingBar, QTooltip, type QuasarPluginOptions} from 'quasar';
import {docReady, isBrowser} from '@odin/utils';
import Vue from 'vue';
import { set } from 'lodash-es';
import { loadIcon } from '@odin/assets';

const iconSet = {};

const setCustomIcon = async (iconName: string, path: string) => {
  const icon = await loadIcon(iconName);
  const svg = decodeURIComponent(icon.replace('data:image/svg+xml;base64,', ''));
  const quasarFormat = svg.match(/d=['"](.*?)['"]/)?.[1];

  set(iconSet, path, quasarFormat);
};

export async function setupQuasar() {
  if (isBrowser) {
    setupQuasarTooltips();
  }

  await Promise.all([
    setCustomIcon('arrow_left', 'tabs.left'),
    setCustomIcon('arrow_left', 'datetime.arrowLeft'),
    setCustomIcon('arrow_right', 'datetime.arrowRight'),
    setCustomIcon('arrow_right', 'tabs.right'),
    setCustomIcon('arrow_right', 'tree.icon'),
    setCustomIcon('arrow_up', 'table.arrowUp'),
    setCustomIcon('arrow_down', 'expansionItem.icon'),
    setCustomIcon('arrow_down', 'arrow.dropdown'),
  ]);

  Vue.use(Quasar, getQuasarOpts());
  Vue.component('QTooltip', QTooltip);
}


export function setupQuasarTooltips(){
  docReady(() => {
    const elm = document.createElement('div');
    // added also lgpi-checkout used by new web not to interfere SPA
    elm.className = 'wsk-root wsk-app wsk-portal ws-typography lgpi-checkout';
    elm.id = 'wsk-root';
    document.body.appendChild(elm);

    // move tooltips to wsk-root element - fixes styles and animations
    const classNames = ['q-tooltip', 'q-menu', 'q-dialog'];
    new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach((node: Node) => {
          if (
            node.nodeName === 'DIV'
            &&
            // @ts-ignore
            classNames.some(className => node.classList.contains(className))
          ) {
            elm.appendChild(node);
          }
        });
      });
    }).observe(document.body, {attributes: false, childList: true, subtree: false});
  });
}


function getQuasarOpts(): Partial<QuasarPluginOptions> {
  return {
    // @ts-ignore
    iconSet,
    directives: {
      Intersection,
    },
    plugins: {
      LoadingBar,
    },
    config: {
      loadingBar: {
        skipHijack: true,
        size: '0px',
      }
    }
  };
}
